//@ts-nocheck

import React from 'react';
import { Button, Classes, Intent } from '@blueprintjs/core';

import { Form } from 'react-final-form';
import { CheckboxInputFormField, SimpleTextFormContent, TextInputFormField } from '../../common/form';
import { Instance } from 'mobx-state-tree';
import { Municipality } from '../../../store/models';
import { TLCode } from '../../../common/enums';
import { TranslatedMessage } from '../../common/translation';
import styled from '@emotion/styled';

interface MunicipalityFormProps {
  municipality?: Instance<typeof Municipality>;
  onSave: (data: any) => void;
  dialogForm?: boolean;
  onClose?: () => void;
  isCreation: boolean;
}

export const MunicipalityForm = ({ municipality, onSave, dialogForm, onClose, isCreation }: MunicipalityFormProps) => {
  return (
    <Form
      initialValues={municipality}
      onSubmit={onSave}
      render={({ handleSubmit, hasValidationErrors, dirty }) => {
        return (
          <form onSubmit={handleSubmit}>
            <TextInputFormField name="insCode" label={TLCode.MUNICIPALITY_INS6Code} inline={true} fill={true} />
            <TextInputFormField name="nameFR" label={TLCode.MUNICIPALITY_EntityNameFr} inline={true} fill={true} />
            <TextInputFormField name="nameNL" label={TLCode.MUNICIPALITY_EntityNameNl} inline={true} fill={true} />
            <TextInputFormField name="postalCode" label={TLCode.MUNICIPALITY_PostalCode} inline={true} fill={true} />
            <DivLine>
              <SimpleTextFormContent label={TLCode.MUNICIPALITY_IsMain} small={false}>
                <CheckboxInputFormField name="isMain" inline={true} disabled={!isCreation} />
              </SimpleTextFormContent>
              <TextInputFormField
                name="population"
                label={TLCode.MUNICIPALITY_Population}
                inline={true}
                fill={true}
                disabled={municipality !== undefined && !municipality.isMain}
              />
            </DivLine>
            <TextInputFormField
              name="mainINSCode"
              label={TLCode.MUNICIPALITY_Ins5Code}
              inline={true}
              fill={true}
              disabled={!isCreation}
            />
            <TextInputFormField
              name="mainNameFR"
              label={TLCode.MUNICIPALITY_MainMunicipalityFr}
              inline={true}
              fill={true}
              disabled={!isCreation}
            />
            <TextInputFormField
              name="mainNameNL"
              label={TLCode.MUNICIPALITY_MainMunicipalityNl}
              inline={true}
              fill={true}
              disabled={!isCreation}
            />
            <div className={Classes.DIALOG_FOOTER}>
              <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                {onClose && dialogForm && (
                  <Button text={<TranslatedMessage id={TLCode.GENERAL_Cancel} />} onClick={onClose} />
                )}
                <Button
                  type="submit"
                  intent={Intent.PRIMARY}
                  disabled={
                    hasValidationErrors || (!dirty && (municipality !== undefined && municipality.municipalityId > 0))
                  }
                  text={<TranslatedMessage id={isCreation ? TLCode.GENERAL_Add : TLCode.GENERAL_Save} />}
                />
              </div>
            </div>
          </form>
        );
      }}
    />
  );
};

const DivLine = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
